import { createAction, props } from '@ngrx/store';
import { WhiteListURLComponentObject } from './whitelist-URL.datamodel';

const LABEL = '[Whitelist URL]';

export const WhiteListRetrieved = createAction(
  `${LABEL} Whitelist retrieved`,
  props<{
    components?: WhiteListURLComponentObject[]
  }>()
);

export const WhiteListURLSaved = createAction(
  `${LABEL} WhiteList URL component saved`,
  props<{
    component?: WhiteListURLComponentObject
  }>()
);

export const WhiteListSetSuccessMessage = createAction(
  `${LABEL} Set success message`,
  props<{
    message: string
  }>()
);

export const WhiteListDeleted = createAction(
  `${LABEL} Whitelist URL component deleted`,
  props<{
    componentId?: string
  }>()
);

export const WhiteListUpdated = createAction(
  `${LABEL} Whitelist URL component updated`,
  props<{
    component?: WhiteListURLComponentObject
  }>()
);

export const WhiteListMetadataUpdated = createAction(
    `${LABEL} Whitelist URL component's metadata updated`,
    props<{
      metadata?: {key: string, value: string}[],
      guid?: string
    }>()
);

export const WhiteListPermissionsRetrieved = createAction(
  `${LABEL} Whitelist URL permissions retrieved`,
  props<{
    whiteListUrlPermissions?: any[]
  }>()
);

export const WhiteListMetadataRetrieved = createAction(
    `${LABEL} Whitelist URL metadata retrieved`,
    props<{
      whiteListUrlMetadata?: any[]
    }>()
);
